import settings from "./settings"

const getValue = (str) => {
    //Check if there is a specific number present
    const matches = str.match(/(\d+)/);
    if (matches && matches[0]) {
        return parseInt(matches[0], 10);
    }
    else {
        //Default pauses
        if (str.includes("pauseFor(")) {
            if (str.includes("comma")) {
                return settings.pauseFor.comma
            }
            else if (str.includes("fullstop")) {
                return settings.pauseFor.fullStop
            }
        }

        if (str.includes("changeDelay(")) {
            if (str.includes("default")) {
                return settings.changeDelay.default
            }
            else if (str.includes("deliberate")) {
                return settings.changeDelay.deliberate
            }
            else if (str.includes("slow")) {
                return settings.changeDelay.slow
            }
            else if (str.includes("very slow")) {
                return settings.changeDelay.verySlow
            }
            else if (str.includes("snail")) {
                return settings.changeDelay.snail
            }
        }

    }
}

const processSpecialTag = (typewriter, string, print) => {
    const value = getValue(string)

    if (value) {
        if (string.includes("pauseFor(")) {
            if (!print && typewriter) {
                typewriter.pauseFor(value)
            }
            return true
        }
        else if (string.includes("changeDelay(")) {
            if (!print && typewriter) {
                typewriter.changeDelay(value)
            }
            return true
        }
        else if (string.includes("deleteChars(")) {
            if (!print && typewriter) {
                typewriter.deleteChars(value)
            }
            return true
        }
        else if (string.includes("changeDeleteSpeed(")) {
            if (!print && typewriter) {
                typewriter.changeDeleteSpeed(value)
            }
            return true
        }
        else if (string.includes("openContents(")) {
            if (!print && typewriter) {
                typewriter.callFunction(() => {
                    console.log("Open contents")
                })
            }
            return true
        }
    }
    return false

}

const addActionsToTypewriter = ({arrayOfActions, typewriter, isEndOfTypewriterBlock, finishedCallback, isResponse, print, chunk, button}) => {

    //Change delay if its a response
    if (isResponse && !print) {
        typewriter.changeDelay(settings.changeDelay.response)
    }

    if (chunk.processedHTML === undefined) {
        chunk.processedHTML = {
            body: ""
        }
    }

    if (button && button.processedHTML === undefined) {
        button.processedHTML = ""
    }
    //Iterate through the finished strings array, which contains arrays of paragraphs
    arrayOfActions.forEach((array, line) => {
        array.forEach((newStr, i) => {

            const isSpecialTag = processSpecialTag(typewriter, newStr, print)

            if (!isSpecialTag) {
                if (isResponse && !print && typewriter) {
                    typewriter
                        .changeCursor("|")
                }

                //Type or paste the string
                if (!print) {
                    if (typewriter) {
                        if (chunk.typeResponse && isResponse) {
                            typewriter.typeString(`${newStr}`)
                        }
                        else if (chunk.typing) {
                            typewriter.typeString(`${newStr}`)
                        }
                        else {
                            typewriter.pasteString(`${newStr}`)
                        }
                    }
                }
                else {
                    if (isResponse) {
                        button.processedHTML = button.processedHTML + newStr
                    } else {
                        chunk.processedHTML.body = chunk.processedHTML.body + newStr
                    }
                }

                if (i == array.length - 1) {

                    //Handle the end of a response
                    if (isResponse) {
                        if (!print) {
                            if (typewriter) {
                                if (!chunk.isLastChunk) {
                                    typewriter
                                        .pauseFor(settings.pauseAfterTypingALine.response)
                                        .typeString(`<br><br>`)
                                        .changeDelay(settings.changeDelay.default)
                                }
                            }
                        }
                        else {
                            button.processedHTML = button.processedHTML + `<br><br>`
                        }
                    }
                    //Handle the end of a standard block of text
                    else {
                        if (isEndOfTypewriterBlock && line == arrayOfActions.length - 1) {
                            if (!print) {
                                if (typewriter) {
                                    typewriter
                                        .typeString("<br>")
                                        .pauseFor(settings.pauseAfterTypingALine.standard)
                                }

                            } else {
                                chunk.processedHTML.body = chunk.processedHTML.body + `<br>`
                            }
                        }
                        else if (line == arrayOfActions.length - 1 && !chunk.nextState) {
                            if (!print) {
                                if (typewriter) {
                                    typewriter
                                        .typeString("<br><br>")
                                        .typeString("> ")
                                }
                            }
                            else {
                                chunk.processedHTML.body = chunk.processedHTML.body + `<br><br>` + `> `
                            }
                        }
                        else {
                            if (!print) {
                                if (typewriter) {
                                    typewriter
                                        .typeString("<br><br>")
                                        .pauseFor(settings.pauseAfterTypingALine.standard)
                                }
                            } else {
                                chunk.processedHTML.body = chunk.processedHTML.body + `<br><br>`
                            }
                        }
                    }
                }

            }

        })
    })

    //Only add a callback if it isn't a response
    if (typewriter && finishedCallback) {
        typewriter
            .callFunction(() => {
                finishedCallback()
            })
    }
}


export default addActionsToTypewriter
